console.log("Product options loaded");

// --- 1. Option Selector Event Listeners ---
const options = document.querySelectorAll("variant-radios input");

options.forEach((element) => {
    element.addEventListener("click", (event) => {
        const target = event.target;
        const level = parseInt(target.dataset.productOptionLevel, 10);
        const nextOptions = target.dataset.productOptionsLevelNextValues;

        disableLowerOptions(level);
        enableNextOptions(nextOptions, level);
    });
});

function checkProductOption() {}

function disableLowerOptions(level) {
    const totalLevels = document.querySelectorAll("variant-radios fieldset").length;

    for (let lowerLevel = level + 1; lowerLevel <= totalLevels + 1; lowerLevel++) {
        const lowerLevelInputs = document.querySelectorAll(`input[data-product-option-level="${lowerLevel}"]`);
        lowerLevelInputs.forEach(element => {
            element.disabled = true;
            element.checked = false;
        });
    }
}

function enableNextOptions(options, level) {
    if (!options) return;

    // Split options by either comma or semicolon
    const optionsArray = options.split(/[,;]\s*/).filter(Boolean);
    const totalLevels = document.querySelectorAll("variant-radios fieldset").length;

    if (level >= totalLevels) { return; }

    if (level >= 2) {
        const variantRadios = document.querySelector('variant-radios');
        if (!variantRadios) return;

        const validCombinations = variantRadios.dataset.validCombinations;
        // Split combinations by either comma or semicolon and clean up spacing
        const combinationsArray = validCombinations 
            ? validCombinations.split(/[,;]/).map(c => c.trim()).filter(Boolean) 
            : [];
        
        const selectedValues = [];
        for (let l = 1; l <= level; l++) {
            const val = document.querySelector(`input[data-product-option-level="${l}"]:checked`)?.value;
            if (val) selectedValues.push(val);
        }

        if (selectedValues.length < level) return;

        const targetLevel = level + 1;
        optionsArray.forEach(nextLevelValue => {
            const combination = [...selectedValues, nextLevelValue].join(" / ");
            const element = Array.from(document.querySelectorAll(`input[data-product-option-level="${targetLevel}"]`))
                .find(input => input.value === nextLevelValue);
            
            const isValid = combinationsArray.some(combo => combo.startsWith(combination) || combo === combination);
            
            if (element) {
                if (isValid) {
                    element.disabled = false;
                } else {
                    element.disabled = true;
                    element.checked = false;
                }
            }
        });

        return;
    }

    // Level 1 -> Level 2 enabling
    for (let index = 0; index < optionsArray.length; index++) {
        const option = optionsArray[index];
        const targetLevel = level + 1;
        const target = Array.from(document.querySelectorAll(`input[data-product-option-level="${targetLevel}"]`))
            .find(input => input.value === option);
        
        if (target) {
            target.disabled = false;
        }
    }
}

// --- 2. Dynamic Auto-Select SKU Logic ---
document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const psq = urlParams.get('_psq');

    if (psq && psq.includes('variants.sku')) {
        const rawSku = psq.split('variants.sku:')[1] || psq.split('variants.sku%3A')[1];
        if (!rawSku) {
            console.warn('[SKU Auto-Select] Could not parse SKU from _psq parameter.');
            return;
        }

        const searchSku = decodeURIComponent(rawSku).trim();

        const jsonScript = document.querySelector('variant-radios script[type="application/json"]');
        if (!jsonScript) {
            console.error('[SKU Auto-Select] Variant JSON script tag not found.');
            return;
        }

        try {
            const variants = JSON.parse(jsonScript.textContent);
            const targetVariant = variants.find(v => v.sku === searchSku);

            if (targetVariant) {
                const findInput = (level, val) => 
                    Array.from(document.querySelectorAll(`input[data-product-option-level="${level}"]`))
                         .find(input => input.value === val);

                // Recursive function to step through all option levels sequentially
                const selectOptionLevel = (currentLevel) => {
                    const optionValue = targetVariant[`option${currentLevel}`];
                    if (!optionValue) return;

                    const input = findInput(currentLevel, optionValue);
                    if (input && !input.disabled) {
                        input.click();
                        setTimeout(() => selectOptionLevel(currentLevel + 1), 150);
                    } else if (input && input.disabled) {
                        console.warn(`[SKU Auto-Select] Level ${currentLevel} option "${optionValue}" is disabled.`);
                    }
                };

                selectOptionLevel(1);

            } else {
                console.warn(`[SKU Auto-Select] No variant matching SKU "${searchSku}" found.`);
            }
        } catch (error) {
            console.error('[SKU Auto-Select] Failed to parse JSON:', error);
        }
    }
});

/* OLD

console.log("Product options loaded");

const options = document.querySelectorAll("variant-radios input");

options.forEach((element) => {
    element.addEventListener("click", (event) => {
        const target = event.target;
        const level = parseInt(target.dataset.productOptionLevel, 10);
        const nextOptions = target.dataset.productOptionsLevelNextValues;

        disableLowerOptions(level);
        enableNextOptions(nextOptions, level);
    });
});

function checkProductOption() {}

function disableLowerOptions(level) {
    for (let index = level; index <= 3; index++) {
        const lowerLevel = index + 1;
        const lowerLevelInputs = document.querySelectorAll(`input[data-product-option-level="${lowerLevel}"]`);
        lowerLevelInputs.forEach(element => {
            element.disabled = true;
            element.checked = false;
        });
    }
}

function enableNextOptions(options, level) {
    const optionsArray = options.split("; ");

    if (level == 3) { return }

    if (level == 2) {
        const validCombinations = document.querySelector('variant-radios').dataset.validCombinations;
        const combinationsArray = validCombinations.split(';');
        const selectedLevel1 = document.querySelector('input[data-product-option-level="1"]:checked').value;
        const selectedLevel2 = document.querySelector('input[data-product-option-level="2"]:checked').value;

        optionsArray.forEach(level3Value => {
            const combination = `${selectedLevel1} / ${selectedLevel2} / ${level3Value}`;
            const element = document.querySelector(`input[data-product-option-level="3"][value="${level3Value}"]`);
            const isValid = combinationsArray.includes(combination);
            if ( isValid ) {
                element.disabled = false;
            } else {
                element.disabled = true;
                element.checked = false;
            }
        });

        return
    }

    for (let index = 0; index < optionsArray.length; index++) {
        const option = optionsArray[index];
        const targetLevel = level + 1;
        const target = document.querySelector(
            `input[data-product-option-level="${targetLevel}"][value="${option}"]`
        );
        target.disabled = false;
    }
}
*/